import { Title } from '@gerdau/hefesto/Title';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActionsFooterFacelift from '../../../../components/ActionsFooterFacelift';
import { ApplicationState } from '../../../../store';
import { sendFabricationPurchaseOrder } from '../../../../store/ducks/fabrication-purchase-order/actions';
import { IFabricationPurchaseOrderState } from '../../../../store/ducks/fabrication-purchase-order/types';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { EFabricationRoutes } from '../fabrication.routes';
import ExtraItensTable from './ExtraItensTable';
import ProjectsTable from './ProjectsTable';
import { CheckoutContentBlock, TitleContainer } from './styles';
import WireTable from './WireTable';

interface IFabricationCheckoutProps {
  goToFabricationRoute(route: EFabricationRoutes): void;
  fabricationPurchaseOrder: IFabricationPurchaseOrderState;
}

const Checkout: React.FC<IFabricationCheckoutProps> = ({
  goToFabricationRoute,
  fabricationPurchaseOrder
}) => {
  const dispatch = useDispatch();

  const isManager = useSelector(
    (appState: ApplicationState) => appState.user.isManager
  );

  const onClickSendOrder = () => {
    dispatch(
      sendTagging({
        screenName: 'LG:Comprar:CorteEDobra:RevisaoDoPedido',
        itemName: 'button:finalizar_pedido',
        itemDescription: 'comprar_corteEDobra_revisaoDoPedido_finalizarPedido',
        event: 'click',
        orderCliente:
          fabricationPurchaseOrder.constructionIdentification.orderNumber,
        contratoObra:
          fabricationPurchaseOrder.constructionIdentification.contractNumber,
        filterInfo: `#cttObra:${
          fabricationPurchaseOrder.constructionIdentification.contractNumber
        }#orderCliente:${
          fabricationPurchaseOrder.constructionIdentification.orderNumber
        }#dtDesejada:${moment(
          fabricationPurchaseOrder.constructionIdentification
            .desiredDate as unknown as Date
        ).format('DD/MM/yyyy')}`
      })
    );

    dispatch(sendFabricationPurchaseOrder(fabricationPurchaseOrder));
  };

  useEffect(() => {
    dispatch(
      sendTagging({
        screenName: 'LG:Comprar:CorteEDobra:RevisaoDoPedido',
        event: 'page_view',
        page: window.location.pathname
      })
    );
  }, []);

  return (
    <>
      <TitleContainer>
        <Title level={2}>Revisão do pedido</Title>
      </TitleContainer>

      {fabricationPurchaseOrder.detailingProject.itens.filter(
        (project) => project.projectId
      ).length > 0 && (
        <ProjectsTable
          detailingProject={fabricationPurchaseOrder.detailingProject}
          goToDetailingProject={() => {
            dispatch(
              sendTagging({
                screenName: 'LG:Comprar:CorteEDobra:RevisaoDoPedido',
                itemName: 'button:editar_projeto',
                itemDescription:
                  'comprar_corteEDobra_revisaoDoPedido_editarProjeto',
                event: 'click'
              })
            );
            goToFabricationRoute(EFabricationRoutes.DETAILING_PROJECT);
          }}
        />
      )}

      {fabricationPurchaseOrder.extraItens.otherPieces.filter(
        (piece) => !!piece.pieceTypeId
      ).length > 0 && (
        <ExtraItensTable
          extraItens={fabricationPurchaseOrder.extraItens}
          goToExtraItens={() => {
            dispatch(
              sendTagging({
                screenName: 'LG:Comprar:CorteEDobra:RevisaoDoPedido',
                itemName: 'button:editar_itens_extras',
                itemDescription:
                  'comprar_corteEDobra_revisaoDoPedido_editarItensExtras',
                event: 'click'
              })
            );
            goToFabricationRoute(EFabricationRoutes.EXTRA_ITENS);
          }}
        />
      )}

      {fabricationPurchaseOrder.extraItens.annealedWires.filter(
        (wire) => !!wire.annealedWireTypeId
      ).length > 0 && (
        <WireTable
          extraItens={fabricationPurchaseOrder.extraItens}
          goToExtraItens={() => {
            dispatch(
              sendTagging({
                screenName: 'LG:Comprar:CorteEDobra:RevisaoDoPedido',
                itemName: 'button:editar_arame_recozido',
                itemDescription:
                  'comprar_corteEDobra_revisaoDoPedido_editarArameRecozido',
                event: 'click'
              })
            );

            goToFabricationRoute(EFabricationRoutes.EXTRA_ITENS);
          }}
        />
      )}

      <ActionsFooterFacelift
        nextStepText="Concluir pedido"
        onBackClick={() => {
          dispatch(
            sendTagging({
              screenName: 'LG:Comprar:CorteEDobra:RevisaoDoPedido',
              itemName: 'button:voltar',
              itemDescription: 'comprar_corteEDobra_revisaoDoPedido_voltar',
              event: 'click',
              orderCliente:
                fabricationPurchaseOrder.constructionIdentification.orderNumber,
              contratoObra:
                fabricationPurchaseOrder.constructionIdentification
                  .contractNumber,
              filterInfo: `#cttObra:${
                fabricationPurchaseOrder.constructionIdentification
                  .contractNumber
              }#orderCliente:${
                fabricationPurchaseOrder.constructionIdentification.orderNumber
              }#dtDesejada:${moment(
                fabricationPurchaseOrder.constructionIdentification
                  .desiredDate as unknown as Date
              ).format('DD/MM/yyyy')}`
            })
          );

          goToFabricationRoute(EFabricationRoutes.EXTRA_ITENS);
        }}
        onNextStepClick={onClickSendOrder}
        disabledNextStep={isManager}
      />

      {isManager && (
        <CheckoutContentBlock>
          <span className="disabled-to-buy">
            Perfil de gerenciamento não pode enviar pedidos de compra.
          </span>
        </CheckoutContentBlock>
      )}
    </>
  );
};

export default Checkout;
